<div class="flip-instance-main-view-card-header">
  <app-header-bar
    (routerLinkClick)="routerLinkClicked()"
    *ngIf="dob != undefined || dob != null"
    [age]="age"
    [dob]="dob"
    [showButton]="false"
    [showClientDetails]="false"
    [title]="_clientName"
  ></app-header-bar>
</div>
<!-- Client Information -->
<div class="dashboard-side-card-container">
  <app-client-information
    [attributes]="_clientInformationAttributes"
    [isVertialOrientation]="true"
    [title]="_clientInformationTitle"
    [urlDisplayText]="_clientInformationDisplayText"
    [url]="_clientInformationUrl"
    id="client-information"
    subtitle=""
  />
</div>
<!-- Sub-Menu -->
<app-sub-menu
  (navigateBackClick)="routerLinkClicked()"
  [clientId]="_clientId"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [showBackButton]="true"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [totalReviews]="_totalReviews"
/>
<div class="flip-instance-main-view-card-container">
  <app-flip-view-main-card
    [assessmentStatus]="'This assessment is locked'"
    [items]="data_collapsible"
    [lastAssessmentDetails]="last_assessment"
    [paddingSize]="'large'"
    [size]="'large'"
  >
  </app-flip-view-main-card>
</div>
